var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM7.78023 40C7.78023 57.7945 22.2055 72.2198 40 72.2198C57.7945 72.2198 72.2198 57.7945 72.2198 40C72.2198 22.2055 57.7945 7.78023 40 7.78023C22.2055 7.78023 7.78023 22.2055 7.78023 40Z",
    fill: "#E4E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 34.7471 78.9654 29.5457 76.9552 24.6927C74.945 19.8396 71.9986 15.4301 68.2843 11.7157C64.5699 8.00138 60.1604 5.05501 55.3073 3.04482C50.4543 1.03463 45.2529 -2.2961e-07 40 0V7.81964C44.226 7.81964 48.4106 8.65201 52.3149 10.2692C56.2192 11.8864 59.7667 14.2568 62.7549 17.2451C65.7432 20.2333 68.1136 23.7808 69.7308 27.6851C71.348 31.5894 72.1804 35.774 72.1804 40H80Z",
    fill: "#091B3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhLoader);
export default __webpack_public_path__ + "static/media/fmh-loader.a3ac746d4fab237c7da2c8f171e415f3.svg";
export { ForwardRef as ReactComponent };